import { Injectable, inject } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { OmniBarService } from "@tylertech/core-module";

@Injectable({ providedIn: "root" })
export class FormTitleService
{
    private readonly $titleService = inject(Title);
    private readonly $omniBarService = inject(OmniBarService);

    protected title: string;

    setTitle(title: string): void
    {
        if (!title || this.title === title)
        {
            return;
        }

        this.title = title;
        this.$omniBarService.title = title;
        // ?TODO - Should this be pushed down into omniBarService?
        this.$titleService.setTitle(title);
    }

    getTitle(): string
    {
        return this.title;
    }
}
